"use strict";

require("core-js/modules/es6.object.define-property");

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var styled_components_1 = __importDefault(require("styled-components"));

var components_1 = require("@lsg/components");

exports.FactComponent = function (_a) {
  var data = _a.data;
  return React.createElement(Fact, null, React.createElement(components_1.Icon, {
    color: components_1.Icon.Colors.SECONDARY,
    size: components_1.Icon.Sizes.MEDIUM,
    name: components_1.Icon.Names[data.text('iconName', 'symbols___questionmark')]
  }), React.createElement(ValueWrapper, null, React.createElement(components_1.H2, {
    asSpan: true
  }, data.text('value')), React.createElement(components_1.Paragraph, {
    noMargin: true
  }, data.text('label'))));
};

var ValueWrapper = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  span {\n    margin: 10px 0 5px 0;\n  }\n\n  @media (max-width: 639px) {\n    span {\n      margin-top: 0;\n    }\n  }\n"], ["\n  span {\n    margin: 10px 0 5px 0;\n  }\n\n  @media (max-width: 639px) {\n    span {\n      margin-top: 0;\n    }\n  }\n"])));
var Fact = styled_components_1["default"].div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  @media (max-width: 639px) {\n    display: flex;\n    text-align: left;\n    align-items: center;\n\n    & > ", " {\n      padding-left: 16px;\n    }\n  }\n"], ["\n  @media (max-width: 639px) {\n    display: flex;\n    text-align: left;\n    align-items: center;\n\n    & > ", " {\n      padding-left: 16px;\n    }\n  }\n"])), ValueWrapper);
var templateObject_1, templateObject_2;